<template>

    <div class="page support-page">
        <v-container class="content-container">
            
            <section class="my-5 my-lg-8">
                <h1 class="font-weight-bold primary--text headline d-flex justify-center align-center mb-6 mb-lg-8">
                    <v-icon size="32" color="primary" class="me-3">mdi-card-text</v-icon>
                    <span>إرسال تذكرة دعم</span>
                </h1>
                <div class="d-flex justify-center">
                    <v-card class="transparent" style="max-width: 700px" flat>
                        <v-card-text class="pb-3 px-lg-8 pt-0">
                            <form @submit.prevent="submitAction">
                                <v-row>
                                    <template v-if="!isAuthed">
                                        <v-col :cols="pcOnly ? 12 : 12" class="mb-2 mb-lg-0">
                                            <v-text-field prepend-inner-icon="mdi-account" outlined hide-details v-model="name" label="الاسم" placeholder="أدخل اسمك بالكامل" />
                                        </v-col>
                                        <v-col :cols="pcOnly ? 12 : 12" class="mb-2 mb-lg-0">
                                            <v-text-field prepend-inner-icon="mdi-email" outlined hide-details v-model="email" label="البريد اﻹلكتروني" placeholder="أدخل البريد اﻹلكتروني" />
                                        </v-col>
                                        <v-col :cols="pcOnly ? 12 : 12" class="mb-2 mb-lg-0">
                                            <v-text-field prepend-inner-icon="mdi-phone" outlined hide-details v-model="phone" label="رقم الهاتف" placeholder="أدخل رقم الهاتف" />
                                            <v-divider class="mt-6" />
                                        </v-col>
                                    </template>
                                    <v-col :cols="pcOnly ? 12 : 12" class="mb-2 mb-lg-0">
                                        <v-text-field prepend-inner-icon="mdi-text" outlined hide-details v-model="title" label="عنوان الموضوع" placeholder="أدخل عنوان الموضوع" />
                                    </v-col>
                                    <v-col cols="12" class="mb-2 mb-lg-0">
                                        <v-textarea rows="6" no-resize outlined hide-details v-model="content"  label="وصف الموضوع" placeholder="أدخل وصف الموضوع"/>
                                    </v-col>
                                    <v-col cols="12" class="d-flex">
                                        <v-spacer />
                                        <v-btn v-if="pcOnly" depressed color="muted" text outlined large :disabled="loading" class="me-2 px-10" @click="reset">إعادة</v-btn>
                                        <v-btn :block="phoneOnly" depressed color="primary" large :loading="loading" :disabled="loading" class="px-12" @click="submitAction">إرسال إلى الدعم</v-btn>
                                    </v-col>
                                </v-row>
                            </form>
                        </v-card-text>
                    </v-card>
                </div>
            </section>
            

        </v-container>
        <div class="mt-6">
            <slot v-if="!isAuthed" name="footer" />
        </div>
    </div>
</template>

<script>

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'

export default {
    components: {
        
    },
    
    data(){
        return {
            loading: false,
            
            name: '',
            email: '',
            phone: '',

            title: '',
            content: '',
            sentTicket: null,
        }
    },
    computed: {
        ticketTypes(){
            return this.appData.support_ticket_types.map(type=>{
                return {value: type.value, text: type.text[this.currentLocale]};
            })
        },
        ...GlobalComputed
    },
    watch: {
        loading(loading){
            this.setLinearLoading(loading);
        },
    },
    methods: {
        validate(){
            if (this.title.trim() && this.content.trim()){
                if (this.isAuthed || (this.name.trim() && this.email.trim() && this.phone.trim())){
                    let data = {
                        title: this.title,
                        content: this.content,
                    };
                    if (!this.isAuthed){
                        data.name = this.name;
                        data.email = this.email;
                        data.phone = this.phone;
                    }
                    return data;
                }else{
                    return false;
                }
            }else{
                return false;
            }
        },
        reset(){
            this.phone = '';
            this.name = '';
            this.email = '';
            this.title = '';
            this.content = '';
        },
        submitAction(){
            if (!this.loading){
                this.sentTicket = null;
                let data = this.validate();
                if (data){
                    this.loading = true;

                    this.$store.dispatch('fastPostAction', {url: `/support-tickets`, data}).then((response)=>{
                        let id = response.data.data.id;
                        this.showMsg('تم إرسال رسالتك إلى الدعم، رقم التذكرة #' + id, 'success');
                        this.loading = false;
                        this.sentTicket = id;
                        this.reset();
                        
                    }).catch((e)=>{
                        this.showMsg("حدثت مشكلة أثناء اﻹرسال");
                        this.loading = false;
                    })

                }else{
                    this.showMsg("لا يمكنك ترك حقل فارغاً");
                }
            }
        },
        ...GlobalMethods
    },
    mounted(){
        
    }
}
</script>

<style lang="scss" scoped>

.search-input{
    width: 280px!important;
    max-width: none!important;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
}
.search-btn{
    border-right: none;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    border: none;
}

</style>
<style lang="scss">


.theme--light.v-tabs > .v-tabs-bar{
    background-color: unset!important;
    .v-tab{
        font-weight: bold;
        letter-spacing: 0!important;
    }
}

</style>